import { Obj, InputEvents, Metrics, ObjectState, Surface, UnresolvedObj } from "../types";
import { createSprite, CreateObjectArgs, drawLine, moveObject } from "../core";

type BorderProps = {
  w: number;
}

type Border = {
  l?: BorderProps;
  r?: BorderProps;
  t?: BorderProps;
  b?: BorderProps;
}

export type CreateBoxArgs = CreateObjectArgs & {
  id?: string;
  w?: number;
  h?: number;
  m?: number; // margin
  border?: Border;
  direction?: "column" | "row"; // defaults to column
  children?: (Obj | UnresolvedObj)[];
}

export const createBoxObject = (args: CreateBoxArgs): (UnresolvedObj | Obj) => {
  const { w = 0, h = 0, x = 0, y = 0, z = 0, border, ...rest } = args;

  const sprite = createSprite({ w, h, fill: 0 });

  return {
    ...rest,
    w,
    h,
    x,
    y,
    z,
    sprite,
    step: (startTime: number, timestamp: number, inputEvents: InputEvents, metrics: Metrics, inFocus: boolean, objectState: ObjectState, surface: Surface, obj: Obj) => {

      obj.sprite = createSprite({ w: obj.w, h: obj.h });

      if (border) {
        if (
          border.t && border.t.w > 1 ||
          border.b && border.b.w > 1 ||
          border.l && border.l.w > 1 ||
          border.r && border.r.w > 1
        ) {
          console.warn("Border width greater than 1 not supported yet");
        }
        if (border.l) drawLine(obj.sprite, 0, 0, 0, obj.h - 1, 1);
        if (border.t) drawLine(obj.sprite, 0, 0, obj.w - 1, 0, 1);
        if (border.r) drawLine(obj.sprite, obj.w - 1, 0, obj.w - 1, obj.h - 1, 1);
        if (border.b) drawLine(obj.sprite, 0, obj.h - 1, obj.w - 1, obj.h - 1, 1);
      }
    }
  }
}